import client from "@irati/utils/services/apollo"
import {DealsPackage} from "@irati/types"
import PBService from "@irati/utils/services"

import dealPackagesQuery, {dealPackagesKey} from "./queries/dealPackage"
import dealTagsForCurrentPackage, {dealTagsForCurrentPackageKey} from "./queries/dealTagsForCurrentPackage"

class DealPackageService extends PBService {
  list(): Promise<DealsPackage[]> {
    return client.query({query: dealPackagesQuery}).then(({data}) => {
      return data[dealPackagesKey].results
    })
  }

  dealTagsForCurrentPackage = () => {
    return client.query({query: dealTagsForCurrentPackage}).then(({data}) => {
      return data[dealTagsForCurrentPackageKey].results
    })
  }
}

const packageService = new DealPackageService({errorHandlers: []})

export default packageService
